import { APICore } from "./apiCore";

const api = new APICore();

const ativarUsuario = (contratoId: string | number) => {
    return api.get(`/ativar-usuario/${contratoId}`);
};

export { ativarUsuario };
